import { render, staticRenderFns } from "./year.vue?vue&type=template&id=ba716c26&scoped=true&"
import script from "./year.vue?vue&type=script&lang=js&"
export * from "./year.vue?vue&type=script&lang=js&"
import style0 from "./year.vue?vue&type=style&index=0&id=ba716c26&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba716c26",
  null
  
)

export default component.exports